import { render, staticRenderFns } from "./classTeacher.vue?vue&type=template&id=1c6a446b&scoped=true&"
import script from "./classTeacher.vue?vue&type=script&lang=js&"
export * from "./classTeacher.vue?vue&type=script&lang=js&"
import style0 from "./classTeacher.vue?vue&type=style&index=0&id=1c6a446b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a446b",
  null
  
)

export default component.exports